import { RestError } from '@azure/core-http';
import { useApi } from '../../../../core/api/api.context';
import { KnownNoteEntityTypes } from './add-note.hook';
import { useMutation, useQueryClient } from 'react-query';
import { QueryKeys } from '../../../../core/queries/query-keys.constants';

export interface AddNoteDto {
  id: string;
  entityType: KnownNoteEntityTypes;
  content: string;
  isPrivate: boolean;
}

export function useMutationAddNote(projectID: string) {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<unknown, RestError, AddNoteDto>(
    async (request) => {
      const dto = {
        content: request.content,
        isPrivate: request.isPrivate
      };
      switch (request.entityType) {
        case KnownNoteEntityTypes.Delivery:
          return await api.deliveriesNotesController.create(request.id, dto);
        case KnownNoteEntityTypes.Order:
          return await api.ordersNotesController.create(request.id, projectID, dto);
        case KnownNoteEntityTypes.User:
          return await api.usersNotesController.create(request.id, dto);
        case KnownNoteEntityTypes.Group:
          return await api.groupsNotesController.create(request.id, dto);
        case KnownNoteEntityTypes.Courier:
          return await api.couriersNotesController.create(request.id, dto);
      }
    },
    {
      onSettled(_, __, variables) {
        queryClient.invalidateQueries(QueryKeys.ADD_NOTE);
        switch (variables.entityType) {
          case KnownNoteEntityTypes.Delivery:
            queryClient.invalidateQueries([QueryKeys.DELIVERIES, variables.id, QueryKeys.NOTES]);
            break;
          case KnownNoteEntityTypes.Order:
            queryClient.invalidateQueries([QueryKeys.ORDERS, variables.id, QueryKeys.NOTES]);
            break;
          case KnownNoteEntityTypes.User:
            queryClient.invalidateQueries([QueryKeys.USERS, variables.id, QueryKeys.NOTES]);
            break;
          // A carrier is a group, and its notes are keyed under the carrier that was read.
          case KnownNoteEntityTypes.Group:
            queryClient.invalidateQueries([QueryKeys.CARRIERS, variables.id, QueryKeys.NOTES]);
            break;
          case KnownNoteEntityTypes.Courier:
            queryClient.invalidateQueries([QueryKeys.COURIERS, variables.id, QueryKeys.NOTES]);
            break;
        }
      }
    }
  );
}
